module.exports = __webpack_public_path__ + "img/解决方案_能源_白.4fc747b5.svg";